import { useAuth0 } from '@auth0/auth0-react';
import { getFlagsmithIdentity, useSetupFlagsmith } from '@core/flagsmith';
import { CenteredComponent } from '@core/components';
import { CircularProgress } from '@mui/material';
import flagsmith from '@flagsmith/flagsmith';
import { useFlagsmithLoading } from '@flagsmith/flagsmith/react';
import { ReactNode, useEffect, useMemo, useState } from 'react';

export const FlagsmithIdentityInit = ({ children }: { children: ReactNode }) => {
  const { isLoading: isAuthLoading, user } = useAuth0();
  const loadingState = useFlagsmithLoading();
  const [isIdentityReady, setIsIdentityReady] = useState(false);

  useSetupFlagsmith();

  const identity = useMemo(() => getFlagsmithIdentity(user), [user]);

  useEffect(() => {
    setIsIdentityReady(false);

    if (isAuthLoading) {
      return;
    }

    if (!identity) {
      setIsIdentityReady(true);
      return;
    }

    flagsmith
      .setContext({
        identity: {
          identifier: identity.identifier,
          traits: identity.traits,
        },
      })
      .catch((error) => {
        console.error('Failed to set Flagsmith identity context:', error);
      })
      .finally(() => {
        setIsIdentityReady(true);
      });
  }, [identity, isAuthLoading]);

  // Handle case where useFlagsmithLoading returns undefined or loading object
  const isFlagsmithLoading = loadingState?.isLoading || loadingState?.isFetching;

  if (isAuthLoading || !isIdentityReady || isFlagsmithLoading) {
    return (
      <CenteredComponent>
        <CircularProgress />
      </CenteredComponent>
    );
  }

  return <>{children}</>;
};
